import { Link } from "@tanstack/react-router";
import { ShoppingCart } from "lucide-react";
import { StatusBadge } from "@/components/shared/status-badge";
import type { CustomerOrder } from "@/hooks/use-customers";
import { formatCurrency, formatDate } from "@/lib/format";

interface CustomerOrdersProps {
  orders: CustomerOrder[];
}

export function CustomerOrders({ orders }: CustomerOrdersProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <ShoppingCart className="h-4 w-4 text-muted-foreground" />
        <h3 className="text-sm font-medium">Orders ({orders.length})</h3>
      </div>

      {orders.length === 0 ? (
        <p className="text-sm text-muted-foreground">No orders yet.</p>
      ) : (
        <div className="space-y-2">
          {orders.map((order) => (
            <Link
              key={order.id}
              to="/dashboard/orders/$orderId"
              params={{ orderId: order.id }}
              className="flex items-center justify-between rounded-lg border border-border bg-muted/30 p-3 hover:bg-muted/50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <StatusBadge status={order.status} />
                <span className="text-sm text-muted-foreground">{formatDate(order.createdAt)}</span>
              </div>
              <span className="text-sm font-medium">{formatCurrency(order.totalCents)}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
